firebird.factory('videoLayoutDragService', [
    'videoGlobalService',
    function (videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            // if picture-in-picture video then that is draggable.
            self.draggableVideo = null;
        }
    }
]);
